import { render, staticRenderFns } from "./Comment_Loading.vue?vue&type=template&id=294321b1&"
import script from "./Comment_Loading.vue?vue&type=script&lang=js&"
export * from "./Comment_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports